(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gpt-pair-builder"] && !Shopify.designMode) return;
  try {
    
function initPairBuilders() {
  document.querySelectorAll('[data-pair-builder]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const status = root.querySelector('[data-pair-status]');
    const add = root.querySelector('[data-pair-add]');
    const messages = JSON.parse(root.querySelector('[data-pair-messages]').textContent);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency});
    const selected = () => [...root.querySelectorAll('[data-pair-check]:checked')];
    let busy = false;
    function update(event) {
      if (selected().length > 2) {
        event.target.checked = false;
        status.textContent = messages.limit;
        return;
      }
      const checks = selected();
      add.disabled = busy || checks.length !== 2;
      if (checks.length !== 2) { status.textContent = messages.choose; return; }
      const prices = checks.map(check => Number(check.closest('article').querySelector('select').selectedOptions[0].dataset.price));
      const saving = Math.round(Math.min(...prices) / 2);
      status.textContent = messages.total + ': ' + money.format((prices[0] + prices[1] - saving) / 100) + ' · ' + messages.save + ' ' + money.format(saving / 100);
    }
    root.addEventListener('change', update);
    add.addEventListener('click', async () => {
      const checks = selected();
      if (busy || checks.length !== 2) return;
      busy = true; add.disabled = true;
      const controls = [...root.querySelectorAll('select,input')];
      controls.forEach(control => control.disabled = true);
      const items = checks.map(check => ({ id: check.closest('article').querySelector('select').value, quantity:1 }));
      try {
        const response = await fetch(root.dataset.addUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || messages.error);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || messages.error;
        busy = false; add.disabled = false;
        controls.forEach(control => control.disabled = false);
      }
    });
  });
}
initPairBuilders();
document.addEventListener('shopify:section:load', initPairBuilders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
